module.exports = __webpack_public_path__ + "d70eae7c098bdf0ad616923c6cbb6775.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/fi-2003.png
// module id = 530
// module chunks = 0